function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}, /*#__PURE__*/React.createElement("path", {
  d: "M39.848 38H2V11h43v3.933"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.076 36.233H5V13h37v2.01M21 38h5c.326 3.143 1 6 4 7H17c3-1 4-4 4-7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40 15h15v33H40z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43 19h9v4h-9zM43 27h9v4h-9z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47.5,
  cy: 39,
  r: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 45h13v2H17z"
}));

var SvgComputer = function SvgComputer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComputer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Computer.951cd2a8.svg";
export { ForwardRef as ReactComponent };